import { AuthStatus, User, AuthCredentials } from '@/interfaces/app/Auth'
import client from '@/services/api/client'
import Axios from 'axios'
import { MutationTree, ActionTree, GetterTree, Module } from 'vuex'
import { UserState } from '@/types/store/user'
import { RootState } from '@/types/store'
import createMessage from '@/services/app/createMessage'
import { MessageType } from '@/interfaces/app/Message'

const mutations: MutationTree<UserState> = {
  setStatus(state, status: AuthStatus) {
    state.status = status
  },
  setToken(state, token: string) {
    state.token = token
  },
  setUser(state, payload: User) {
    state.user = payload
  },
}

const actions: ActionTree<UserState, RootState> = {
  login({ commit, dispatch }, credentials: AuthCredentials) {
    return new Promise((resolve, reject) => {
      commit('setStatus', AuthStatus.Pending)
      client({
        url: `/v1/login`,
        method: 'POST',
        data: JSON.stringify(credentials),
      })
        .then(data => {
          const token = data.access_token
          const userData: User = {
            username: credentials.username,
          }
          Axios.defaults.headers.common.Authorization = token
          commit('setToken', token)
          commit('setUser', userData)
          commit('setStatus', AuthStatus.Success)
          resolve(data)
        })
        .catch(error => {
          const message = createMessage(
            'Neplatné přihlašovací údaje',
            MessageType.Error
          )
          dispatch('app/addTempMessage', { message }, { root: true })
          commit('setStatus', AuthStatus.Error)
          commit('setToken', '')
          reject(error)
        })
    })
  },
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      commit('setStatus', AuthStatus.Pending)
      commit('setToken', '')
      delete Axios.defaults.headers.common.Authorization
      resolve()
    })
  },
  getToken({ state }) {
    return state.token
  },
}

const getters: GetterTree<UserState, RootState> = {
  isLoggedIn: (state): boolean => !!state.token,
  user: (state): User | undefined => state.user,
  token: (state): string => state.token,
}

export const user: Module<UserState, RootState> = {
  namespaced: true,
  state: {
    status: AuthStatus.Pending,
    token: '',
    user: { username: '' },
  },
  mutations,
  actions,
  getters,
}

export default user
